export interface AgreementItem {
  id: number;
  agreementId: number;
  sourceType: string;
  sourceId?: number;
  description: string;
  originalAmount: number;
  agreedAmount: number;
  createdAt: Date | string;
  updatedAt?: Date | string;
  createdBy?: string;
}

export interface AgreementPayment {
  id: number;
  agreementId: number;
  installmentNumber: number;
  dueDate: Date | string;
  amount: number;
  status: string;
  paidAt?: Date | string;
  paidBy?: string;
  paymentMethod?: string;
  receipt?: string;
  createdAt: Date | string;
  updatedAt?: Date | string;
  createdBy?: string;
  updatedBy?: string;
}

export interface Agreement {
  id: number;
  agreementNumber: string;
  vehicleRentalId?: number;
  vehicleRentalNumber?: string;
  customerId: number;
  customerName?: string;
  status: string;
  totalOriginalAmount: number;
  totalAgreedAmount: number;
  discount: number;
  dueDate: Date | string;
  installments: number;
  notes?: string;
  terms?: string;
  items: AgreementItem[];
  payments: AgreementPayment[];
  createdAt: Date | string;
  updatedAt?: Date | string;
  createdBy?: string;
  updatedBy?: string;
}

export interface PendingReceivable {
  id: number;
  documentNumber: string;
  dueDate: Date | string;
  originalAmount: number;
  amountToReceive: number;
  status: string;
  category: string;
  description: string;
}

export interface CreateAgreementPayload {
  agreement: Partial<Agreement>;
  items: Partial<AgreementItem>[];
  installments: number;
  createdBy: string;
}

export interface MarkPaymentPaidPayload {
  paidBy: string;
  paymentMethod: string;
  receipt?: string;
  updatedBy: string;
}
